var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalContentContentReadLookAtPicturesSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#bda6cc",
    height: "800px",
    width: "800px",
    baseProfile: "tiny",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-351 153 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-155.6,298c-1.3-3.9-5-6.8-9.1-6.8h-4.7V178.9c0-11.6-9.3-20.9-20.9-20.9h-112.1c-11.6,0-20.9,9.3-20.9,20.9v181 c0,11.6,9.3,20.9,20.9,20.9h111.9c1.3,0,2.3,1.1,2.3,2.3c0,1.3-1.1,2.3-2.3,2.3H-235l34.5,20h77.9L-155.6,298z M-246.2,372.1 c-3.1,0-5.4-2.3-5.4-5.4c0-3.1,2.3-5.4,5.4-5.4c3.1,0,5.4,2.3,5.4,5.4C-240.8,369.8-243,372.1-246.2,372.1z M-184.5,291.3h-20.2 c-5.2,0-9.6,4.4-9.6,9.6c0,5.2,4.4,9.6,9.6,9.6h20.2v42H-308V186.1h123.5V291.3z M-219.6,240.4l-24.4,13l-20.9-42.8l-30.6,59.7h95.5 L-219.6,240.4z M-212.1,213.7c6,0,10.9,4.9,10.9,10.9c0,6-4.9,10.9-10.9,10.9c-6,0-10.9-4.9-10.9-10.9 C-223,218.6-218.1,213.7-212.1,213.7z M-300.9,274h109.5v7.4h-109.5V274z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalContentContentReadLookAtPicturesSvgrepoCom);
export default __webpack_public_path__ + "static/media/digital-content-content-read-look-at-pictures-svgrepo-com.239d0913765c8f0c111cee82ba3b5ca3.svg";
export { ForwardRef as ReactComponent };